import { CONFIG_SEE_AGENDA } from "../../common/constants";

export interface IUserConfigurationGlobal {
	ExchangeServer?: IExchangeServer;
	Outlook?: IOutlook
	records?: (obj: object) => void;
	record?: (value: any, key: string) => void;
}

export class UserConfigurationGlobal implements IUserConfigurationGlobal {
	public ExchangeServer: IExchangeServer;
	public Outlook: IOutlook;
	constructor(props?: IUserConfigurationGlobal) {
		this.ExchangeServer = props.ExchangeServer || new ExchangeServer({});
		this.Outlook = props.Outlook || new Outlook({});
	}
	
	records(obj: object) {
		Object.keys((key: string) => {
			this[key] = obj[key];
		})
	}
	
	record(value: any, key: string) {
		this[key] = value;
	}
}

export interface IExchangeServer {
	Server?: string;
	Email?: string;
	User?: string;
	Password?: string;
	Version?: string;
	Calendar?: string;
	IsOutlookSync?: boolean;
	IsAuthentication?: boolean;
	IsSyncAuto?: boolean;
	IsDisableAccount?: boolean;
	records?: (obj: object) => void;
	record?: (value: any, key: string) => void;
}

export class ExchangeServer implements IExchangeServer {
	Server?: string;
	Email?: string;
	User?: string;
	Password?: string;
	Version?: string;
	Calendar?: string;
	IsOutlookSync?: boolean;
	IsAuthentication?: boolean;
	IsSyncAuto?: boolean;
	IsDisableAccount?: boolean;
	
	constructor(props?: IExchangeServer) {
		this.Server = props.Server || '';
		this.Email = props.Email || '';
		this.User = props.User || '';
		this.Password = props.Password || '';
		this.Version = props.Version || '';
		this.Calendar = props.Calendar || '';
		this.IsOutlookSync = props.IsOutlookSync || false;
		this.IsAuthentication = props.IsAuthentication || false;
		this.IsSyncAuto = props.IsSyncAuto || false;
		this.IsDisableAccount = props.IsDisableAccount || false;
	}
	
	records(obj: object) {
		Object.keys((key: string) => {
			this[key] = obj[key];
		})
	}
	
	record(value: any, key: string) {
		this[key] = value;
	}
}

export interface IOutlook {
	AppointmentType?: number;
	ImportDaysInPast?: number;
	ImportDaysInFuture?: number;
	ExportDaysInPast?: number;
	ExportDaysInFuture?: number;
	IsImportAgendaOption?: boolean;
	IsImportAgenda?: boolean;
	IsExportAgenda?: boolean;
	IsOnlyStartTime?: boolean;
	records?: (obj: object) => void;
	record?: (value: any, key: string) => void;
}

export class Outlook implements IOutlook{
	AppointmentType?: number;
	ImportDaysInPast?: number;
	ImportDaysInFuture?: number;
	ExportDaysInPast?: number;
	ExportDaysInFuture?: number;
	IsImportAgendaOption?: boolean;
	IsImportAgenda?: boolean;
	IsExportAgenda?: boolean;
	IsOnlyStartTime?: boolean;
	constructor(props?: IOutlook) {
		this.AppointmentType = props.AppointmentType || null;
		this.ImportDaysInPast = props.ImportDaysInPast || null;
		this.ImportDaysInFuture = props.ImportDaysInFuture || null;
		this.ExportDaysInPast = props.ExportDaysInPast || null;
		this.ExportDaysInFuture = props.ExportDaysInFuture || null;
		this.IsImportAgendaOption = props.IsImportAgendaOption || false;
		this.IsImportAgenda = props.IsImportAgenda || false;
		this.IsExportAgenda = props.IsExportAgenda || false;
		this.IsOnlyStartTime = props.IsOnlyStartTime || false;
	}
	records(obj: object) {
		Object.keys((key: string) => {
			this[key] = obj[key];
		})
	}
	
	record(value: any, key: string) {
		this[key] = value;
	}
}

export interface IUserconfiguration {
    Id: number;
    Name?: string;
    ShortName?: string;
    Email?: string;
    DirectPhone?: string;
    MobilePhone?: string;
    PhotoUrl?: string;
    AvatarUrl?: string;
    ScannedSignatureUrl?: string;
    GraphicSignatureUrl?: string;
    GroupId?: number;
    DepartmentId?: number;
    SiteId?: number;
    IsActive?: boolean;
    TempAvatar?: string;
    IPI?: string;
    FunctionNL?: string;
    FunctionFR?: string;
    FunctionEN?: string;
}

export class UserConfiguration implements IUserconfiguration {
    Id: number;
    Name?: string;
    ShortName?: string;
    Email?: string;
    DirectPhone?: string;
    MobilePhone?: string;
    PhotoUrl?: string;
    AvatarUrl?: string;
    ScannedSignatureUrl?: string;
    GraphicSignatureUrl?: string;
    GroupId?: number;
    DepartmentId?: number;
    SiteId?: number;
    IsActive?: boolean;
    TempAvatar?: string;
    IPI?: string;
    FunctionNL?: string;
    FunctionFR?: string;
    FunctionEN?: string;

    constructor(option?: IUserconfiguration) {
        this.Id = option.Id || null;
        this.ShortName = option.ShortName || null;
        this.Name = option.Name || null;
        this.Email = option.Email || null;
        this.DirectPhone = option.DirectPhone || null;
        this.MobilePhone = option.MobilePhone || null;
        this.PhotoUrl = option.PhotoUrl || null;
        this.AvatarUrl = option.AvatarUrl || null;
        this.ScannedSignatureUrl = option.ScannedSignatureUrl || null;
        this.GraphicSignatureUrl = option.GraphicSignatureUrl || null;
        this.GroupId = option.GroupId || null;
        this.DepartmentId = option.DepartmentId || null;
        this.SiteId = option.SiteId || null;
        this.IsActive = option.IsActive || false;
        this.TempAvatar = option.TempAvatar || null;
        this.IPI = option.IPI || null;
        this.FunctionNL = option.FunctionNL || null;
        this.FunctionFR = option.FunctionFR || null;
        this.FunctionEN = option.FunctionEN || null;
    }

}
export interface ITaskInAgenda {
    DaysInPast: number;
    DaysInFuture: number;
    TaskType: number;
    IsHideIcons: boolean;
    IsSendMailWhenChangedTask: boolean;
    IsSendMailWhenChangedTaskByAnotherUser: boolean;
}

export class TaskInAgenda implements ITaskInAgenda {
    DaysInPast: number;
    DaysInFuture: number;
    TaskType: number;
    IsHideIcons: boolean;
    IsSendMailWhenChangedTask: boolean;
    IsSendMailWhenChangedTaskByAnotherUser: boolean;

    constructor(option?: ITaskInAgenda) {
        this.DaysInPast = option.DaysInPast || null
        this.DaysInFuture = option.DaysInFuture || null
        this.TaskType = option.TaskType || null
        this.IsHideIcons = option.IsHideIcons || false
        this.IsSendMailWhenChangedTask = option.IsSendMailWhenChangedTask || false
        this.IsSendMailWhenChangedTaskByAnotherUser = option.IsSendMailWhenChangedTaskByAnotherUser || false
    }
}

export interface IUserConfigAgenda {
    StartTime: string;
    ShowAppointmentTypeId: number;
    RowHeight: number;
    FontSizeSchedule: number;
    FontWeightScheduleId: number;
    FontSizeTime: number;
    HideIcons: boolean;
    ShowAppointmentTime: boolean;
    SendMailWhenChangedAppointment: boolean;
    SendMailWhenChangedAppointmentByAnotherUser: boolean;
    InitialiseInternalComment: boolean;
    MoveAppointmentConfirm: boolean;
    AutoAddManagerToAgendaUser: boolean;
    OnlyAddManagerToAgendaUser: boolean;
    HasSharingUsers: boolean;
    SharingUserIds: string;
    DefaultAlarmId: number;
    Type?: number;
    ShareAgendaOption: CONFIG_SEE_AGENDA | null;
}

export class UserConfigAgenda implements IUserConfigAgenda {
    StartTime: string;
    ShowAppointmentTypeId: number;
    RowHeight: number;
    FontSizeSchedule: number;
    FontWeightScheduleId: number;
    FontSizeTime: number;
    HideIcons: boolean;
    ShowAppointmentTime: boolean;
    SendMailWhenChangedAppointment: boolean;
    SendMailWhenChangedAppointmentByAnotherUser: boolean;
    InitialiseInternalComment: boolean;
    MoveAppointmentConfirm: boolean;
    AutoAddManagerToAgendaUser: boolean;
    OnlyAddManagerToAgendaUser: boolean;
    HasSharingUsers: boolean;
    SharingUserIds: string;
    DefaultAlarmId: number;
    ShareAgendaOption: CONFIG_SEE_AGENDA | null;

    constructor(option?: IUserConfigAgenda) {
        this.StartTime = option.StartTime || null
        this.ShowAppointmentTypeId = option.ShowAppointmentTypeId || null
        this.RowHeight = option.RowHeight || null
        this.FontSizeSchedule = option.FontSizeSchedule || null
        this.FontWeightScheduleId = option.FontWeightScheduleId || null
        this.FontSizeTime = option.FontSizeTime || null
        this.HideIcons = option.HideIcons || false
        this.ShowAppointmentTime = option.ShowAppointmentTime || false
        this.SendMailWhenChangedAppointment = option.SendMailWhenChangedAppointment || false
        this.SendMailWhenChangedAppointmentByAnotherUser = option.SendMailWhenChangedAppointmentByAnotherUser || false
        this.InitialiseInternalComment = option.InitialiseInternalComment || false
        this.MoveAppointmentConfirm = option.MoveAppointmentConfirm || false
        this.AutoAddManagerToAgendaUser = option.AutoAddManagerToAgendaUser || false
        this.OnlyAddManagerToAgendaUser = option.OnlyAddManagerToAgendaUser || false
        this.HasSharingUsers = option.HasSharingUsers || false
        this.SharingUserIds = option.SharingUserIds || null
        this.DefaultAlarmId = option.DefaultAlarmId || null
        this.ShareAgendaOption = option.ShareAgendaOption || null
    }
}

export interface IOutlookSync {
    AppointmentType: number;
    ImportDaysInPast: number;
    ImportDaysInFuture: number;
    ExportDaysInPast: number;
    ExportDaysInFuture: number;
    IsImportAgendaOption: boolean;
    IsImportAgenda: boolean;
    IsExportAgenda: boolean;
    IsOnlyStartTime: boolean;
}

export class OutlookSync implements IOutlookSync {
    AppointmentType: number;
    ImportDaysInPast: number;
    ImportDaysInFuture: number;
    ExportDaysInPast: number;
    ExportDaysInFuture: number;
    IsImportAgendaOption: boolean;
    IsImportAgenda: boolean;
    IsExportAgenda: boolean;
    IsOnlyStartTime: boolean;

    constructor(option?: IOutlookSync) {
        this.AppointmentType = option.AppointmentType || null
        this.ImportDaysInPast = option.ImportDaysInPast || null
        this.ImportDaysInFuture = option.ImportDaysInFuture || null
        this.ExportDaysInPast = option.ExportDaysInPast || null
        this.ExportDaysInFuture = option.ExportDaysInFuture || null
        this.IsImportAgendaOption = option.IsImportAgendaOption || false
        this.IsImportAgenda = option.IsImportAgenda || false
        this.IsExportAgenda = option.IsExportAgenda || false
        this.IsOnlyStartTime = option.IsOnlyStartTime || false
    }
}

export interface ISyncPersonInfo {
    ImportContact: boolean;
    ImportContactModifiedDaysInPast: number;
    ImportContactIsOverwritePerson: boolean;
    ImportContactCategory: number;
    ExportContact: boolean;
    ExportContactModifiedDaysInPast: number;
    ExportRelationsOfActiveProperties: boolean;
    CategoriesSyncPerson: string;
}

export class SyncPersonInfo implements ISyncPersonInfo {
    ImportContact: boolean;
    ImportContactModifiedDaysInPast: number;
    ImportContactIsOverwritePerson: boolean;
    ImportContactCategory: number;
    ExportContact: boolean;
    ExportContactModifiedDaysInPast: number;
    ExportRelationsOfActiveProperties: boolean;
    CategoriesSyncPerson: string;

    constructor(option?: ISyncPersonInfo) {
        this.ImportContact = option.ImportContact || false
        this.ImportContactModifiedDaysInPast = option.ImportContactModifiedDaysInPast || null
        this.ImportContactIsOverwritePerson = option.ImportContactIsOverwritePerson || false
        this.ImportContactCategory = option.ImportContactCategory || null
        this.ExportContact = option.ExportContact || false
        this.ExportContactModifiedDaysInPast = option.ExportContactModifiedDaysInPast || null
        this.ExportRelationsOfActiveProperties = option.ExportRelationsOfActiveProperties || false
        this.CategoriesSyncPerson = option.CategoriesSyncPerson || null
    }
}

export interface IExchangeConfig {
    DisableAccountExchange: boolean;
    ExchangeAuthentication: boolean;
    ExchangeEmail: string;
    ExchangeServer: string;
    ExchangeUsername: string;
    ExchangePassword: string;
    UseSyncOutlook: boolean;
    ExportAuto: boolean;
    ExchangeVersion: string;
    SyncCalendarId: string;
    IsUseChangeFolderCalendar: boolean;
}

export class ExchangeConfig implements IExchangeConfig {
    DisableAccountExchange: boolean;
    ExchangeAuthentication: boolean;
    ExchangeEmail: string;
    ExchangeServer: string;
    ExchangeUsername: string;
    ExchangePassword: string;
    UseSyncOutlook: boolean;
    ExportAuto: boolean;
    ExchangeVersion: string;
    SyncCalendarId: string;
    IsUseChangeFolderCalendar: boolean;

    constructor(option?: IExchangeConfig) {
        this.DisableAccountExchange = option.DisableAccountExchange || false;
        this.ExchangeAuthentication = option.ExchangeAuthentication || false;
        this.ExchangeEmail = option.ExchangeEmail || null;
        this.ExchangeServer = option.ExchangeServer || null;
        this.ExchangeUsername = option.ExchangeUsername || null;
        this.ExchangePassword = option.ExchangePassword || null;
        this.ExchangePassword = option.ExchangePassword || null;
        this.ExportAuto = option.ExportAuto || false;
        this.ExchangeVersion = option.ExchangeVersion || null;
        this.SyncCalendarId = option.SyncCalendarId || null;
        this.IsUseChangeFolderCalendar = option.IsUseChangeFolderCalendar || false;
    }
}

export interface IAccountConfiguration {
    TasksInAgenda: ITaskInAgenda;
    Agenda: IUserConfigAgenda;
    OutlookSync: IOutlookSync;
    SyncPersonsInfo: ISyncPersonInfo;
    ExchangeConfig: IExchangeConfig;
    OtherConfiguration?: any;
}

export class AccountConfiguration implements IAccountConfiguration {
    TasksInAgenda: ITaskInAgenda;
    Agenda: IUserConfigAgenda;
    OutlookSync: IOutlookSync;
    SyncPersonsInfo: ISyncPersonInfo;
    ExchangeConfig: IExchangeConfig;
    OtherConfiguration?: any;

    constructor(option?: IAccountConfiguration) {
        this.TasksInAgenda = option.TasksInAgenda || new TaskInAgenda();
        this.Agenda = option.Agenda || new UserConfigAgenda();
        this.OutlookSync = option.OutlookSync || new OutlookSync();
        this.SyncPersonsInfo = option.SyncPersonsInfo || new SyncPersonInfo();
        this.ExchangeConfig = option.ExchangeConfig || new ExchangeConfig();
        this.OtherConfiguration = option.OtherConfiguration;
    }
}

export interface ITwoFactorAuth {
    EnableTwoFA?: boolean;
    UserId?: number;
    AuthMode?: string;
    OtpAuth?: string;
}

export class TwoFactorAuth implements ITwoFactorAuth {
    EnableTwoFA?: boolean;
    UserId?: number;
    AuthMode?: string;
    OtpAuth?: string;

    constructor(option?: ITwoFactorAuth) {
        this.EnableTwoFA = option.EnableTwoFA || false;
        this.UserId = option.UserId || null;
        this.AuthMode = option.AuthMode || null;
        this.OtpAuth = option.OtpAuth || null;
    }
}

export interface IAppointmentNotification {
    NotificationAppointmentChanged?: boolean;
    NotificationAppointmentChangedByAnotherUser?: boolean;
    NotificationAppointmentNotFeedback?: boolean;
    NotificationAppointmentOpenFullSlots?: boolean;
    SendMailWhenChangedAppointment?: boolean;
    SendMailWhenChangedAppointmentByAnotherUser?: boolean;
}

export interface ITaskNotification {
    NotificationTaskChanged?: boolean;
    NotificationTaskChangedByAnotherUser?: boolean;
    SendMailWhenChangedTask?: boolean;
    SendMailWhenChangedTaskByAnotherUser?: boolean;
}
export interface IOtherNotification {
    NotificationPortalIncomingEmail?: boolean;
    NotificationIncomingSms?: boolean;
    NotificationObjectChecklistDone?: boolean;
}
export interface INotificationConfig {
    Appointment?: IAppointmentNotification
    Task?: ITaskNotification
    Others?: IOtherNotification
}

export class NotificationConfig implements INotificationConfig{
    Appointment?: IAppointmentNotification
    Task?: ITaskNotification
    Others?: IOtherNotification

    constructor(option?: INotificationConfig) {
        this.Appointment = option.Appointment || null;
        this.Task = option.Task || null;
        this.Others = option.Others || null;
    }
}